module.exports = __webpack_public_path__ + "img/totsections.76a83072.svg";